import { render, staticRenderFns } from "./SmeButtonLink.vue?vue&type=template&id=86061a7a&scoped=true&"
import script from "./SmeButtonLink.vue?vue&type=script&setup=true&lang=js&"
export * from "./SmeButtonLink.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SmeButtonLink.vue?vue&type=style&index=0&id=86061a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86061a7a",
  null
  
)

export default component.exports